import { Typography } from "@timeedit/ui-components";
import { translations } from "@timeedit/registration-shared";
import "./successIcon.scss";
import CheckOutlined from "@timeedit/ui-components/icons/CheckOutlined";

type SuccessIconProps = {
  useText?: boolean;
  className?: string;
};

export function SuccessIcon({
  useText,
  className = "event-success-icon",
}: SuccessIconProps): React.JSX.Element {
  return (
    <span className={className}>
      <CheckOutlined alt="Success" />
      {useText && (
        <Typography.Text className="event-success-icon__text">
          {translations.registered}
        </Typography.Text>
      )}
    </span>
  );
}
